const translation = {
  pageTitle: '嗨，近来可好',
  welcome: '👋 欢迎来到 Dify, 登录以继续',
  email: '邮箱',
  emailPlaceholder: '输入邮箱地址',
  password: '密码',
  passwordPlaceholder: '输入密码',
  name: '用户名',
  namePlaceholder: '输入用户名',
  forget: '忘记密码？',
  signBtn: '登录',
  continueWithCode: '发送验证码',
  sendVerificationCode: '发送验证码',
  usePassword: '使用密码登录',
  useVerificationCode: '使用验证码登录',
  or: '或',
  installBtn: '设置',
  setAdminAccount: '设置管理员账户',
  setAdminAccountDesc: '管理员拥有的最大权限，可用于创建应用和管理 LLM 供应商等。',
  createAndSignIn: '创建账户',
  oneMoreStep: '还差一步',
  createSample: '基于这些信息，我们将为您创建一个示例应用',
  invitationCode: '邀请码',
  invitationCodePlaceholder: '输入邀请码',
  interfaceLanguage: '界面语言',
  timezone: '时区',
  go: '跳转至 Dify',
  sendUsMail: '发封邮件介绍你自己，我们会尽快处理。',
  acceptPP: '我已阅读并接受隐私政策',
  reset: '请运行以下命令重置密码',
  withGitHub: '使用 GitHub 登录',
  withGoogle: '使用 Google 登录',
  withSSO: '使用 SSO 登录',
  rightTitle: '释放大型语言模型的全部潜能',
  rightDesc: '简单构建可视化、可运营、可改进的 AI 应用',
  tos: '使用协议',
  pp: '隐私政策',
  tosDesc: '使用即代表您同意我们的',
  goToInit: '如果您还没有初始化账户，请前往初始化页面',
  dontHave: '还没有邀请码？',
  invalidInvitationCode: '无效的邀请码',
  accountAlreadyInited: '账户已经初始化',
  forgotPassword: '忘记密码？',
  resetLinkSent: '重置链接已发送',
  sendResetLink: '发送重置链接',
  backToSignIn: '返回登录',
  forgotPasswordDesc: '请输入您的电子邮件地址以重置密码。我们将向您发送一封电子邮件，包含如何重置密码的说明。',
  checkEmailForResetLink: '请检查您的电子邮件以获取重置密码的链接。如果几分钟内没有收到，请检查您的垃圾邮件文件夹。',
  passwordChanged: '立即登录',
  changePassword: '设置密码',
  changePasswordTip: '请输入您的新密码',
  changePasswordBtn: '设置密码',
  invalidToken: '无效或已过期的令牌',
  confirmPassword: '确认密码',
  confirmPasswordPlaceholder: '确认您的新密码',
  passwordChangedTip: '您的密码已成功更改',
  error: {
    emailEmpty: '邮箱不能为空',
    emailInValid: '请输入有效的邮箱地址',
    nameEmpty: '用户名不能为空',
    passwordEmpty: '密码不能为空',
    passwordInvalid: '密码必须包含字母和数字，且长度不小于 8 位',
    passwordLengthInValid: '密码必须至少为 8 个字符',
    registrationNotAllowed: '账户不存在，请联系系统管理员注册账户',
  },
  license: {
    tip: '启动 Dify 社区版之前，请阅读 GitHub 上的',
    link: '开源协议',
  },
  join: '加入 ',
  joinTipStart: '邀请你加入 ',
  joinTipEnd: ' 团队',
  invalid: '链接已失效',
  explore: '探索 Dify',
  activatedTipStart: '您已加入',
  activatedTipEnd: '团队',
  activated: '现在登录',
  adminInitPassword: '管理员初始化密码',
  validate: '验证',
  sso: '使用 SSO 继续',
  checkCode: {
    checkYourEmail: '验证您的电子邮件',
    tips: '验证码已经发送到您的邮箱 <strong>{{email}}</strong>',
    validTime: '请注意验证码 5 分钟内有效',
    verificationCode: '验证码',
    verificationCodePlaceholder: '输入 6 位验证码',
    verify: '验证',
    didNotReceiveCode: '没有收到验证码？',
    resend: '重新发送',
    useAnotherMethod: '使用其他方式登录',
    emptyCode: '验证码不能为空',
    invalidCode: '验证码无效',
  },
  resetPassword: '重置密码',
  resetPasswordDesc: '请输入您的电子邮件地址以重置密码。我们将向您发送一封电子邮件。',
  backToLogin: '返回登录',
  setYourAccount: '设置您的账户',
  enterYourName: '请输入用户名',
  back: '返回',
  noLoginMethod: '未配置身份认证方式',
  noLoginMethodTip: '请联系系统管理员添加身份认证方式',
  licenseExpired: '许可证已过期',
  licenseExpiredTip: '您所在空间的 Dify Enterprise 许可证已过期，请联系管理员以继续使用 Dify。',
  licenseLost: '许可证丢失',
  licenseLostTip: '无法连接 Dify 许可证服务器，请联系管理员以继续使用 Dify。',
  licenseInactive: '许可证未激活',
  licenseInactiveTip: '您所在空间的 Dify Enterprise 许可证尚未激活，请联系管理员以继续使用 Dify。',
  webapp: {
    noLoginMethod: 'Web 应用未配置身份认证方式',
    noLoginMethodTip: '请联系系统管理员添加身份认证方式',
    disabled: 'Web 应用身份认证已禁用，请联系系统管理员启用。您也可以尝试直接使用应用。',
  },
}

export default translation
